import { getGarmentInspirationImage, hasGarmentInspirationCategory } from '../data/garmentInspirationImages';

function encodeAssetPath(p) {
  if (typeof p !== 'string' || !p) return p;
  const qIdx = p.indexOf('?');
  const pathPart = qIdx >= 0 ? p.slice(0, qIdx) : p;
  const query = qIdx >= 0 ? p.slice(qIdx) : '';
  if (!pathPart.startsWith('/')) return encodeURI(p);
  const encoded = pathPart
    .split('/')
    .map((segment) => (segment ? encodeURIComponent(segment) : segment))
    .join('/');
  return encoded + query;
}

function toAbsoluteUrl(u) {
  if (!u) return u;
  const s = String(u);
  if (/^(https?:)?\/\//i.test(s)) return s;
  if (s.startsWith('data:') || s.startsWith('blob:')) return s;
  if (s.startsWith('/') && typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${s}`;
  }
  if (s.startsWith('/')) return `https://fashdeck.com${s}`;
  return s;
}

export function hasCustomizationSelections(customizationObj, userReferences = {}) {
  if (userReferences && typeof userReferences === 'object') {
    for (const ref of Object.values(userReferences)) {
      if (ref?.imageUrl) return true;
    }
  }
  if (!customizationObj || typeof customizationObj !== 'object') return false;
  return Object.values(customizationObj).some((arr) => Array.isArray(arr) && arr.length > 0);
}

export function buildGarmentInspirationImageUrl(categoryValue, typeValue, kidAgeRange = null) {
  if (!hasGarmentInspirationCategory(categoryValue)) return null;
  const src = getGarmentInspirationImage(categoryValue, typeValue, kidAgeRange);
  if (!src) return null;
  return toAbsoluteUrl(encodeAssetPath(src));
}

export function resolveGarmentInspirationForProductType(productType, kidAgeRange = null) {
  if (!productType) return null;
  const customization = productType.customization || null;
  const userRefs = productType.customizationUserReferences || {};
  if (hasCustomizationSelections(customization, userRefs)) return null;
  if (productType.garmentInspirationImage) return productType.garmentInspirationImage;
  const category = productType.category;
  const typeValue = productType.finalValue || productType.value;
  return buildGarmentInspirationImageUrl(category, typeValue, kidAgeRange);
}
